<p [style.padding]="'6px 14px'" [style.text-align]="'center'">
  {{ prompt ?? ('Click anywhere on the board to insert this formula.' | translate) }}
</p>
